import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { VetSettingsService } from '../../../services/vet-settings.service';
import * as VetSettingsActions from './vet-settings.actions';


@Injectable()
export class VetSettingsEffects {

  loadMediaCategories$ = createEffect(() => this.actions$.pipe(
    ofType(VetSettingsActions.loadMediaCategories),
    mergeMap(({ viewerTemplateId}) =>
      this.vetSettingsService.getMediaCategories(viewerTemplateId).pipe(
        map(mediaCategories => VetSettingsActions.loadMediaCategoriesSuccess({ mediaCategories })),
        catchError(error => of(VetSettingsActions.loadMediaCategoriesFailure({ error })))
      )
    )
  ));

  loadViewerTemplates$ = createEffect(() => this.actions$.pipe(
    ofType(VetSettingsActions.loadViewerTemplates),
    mergeMap(() =>
      this.vetSettingsService.getViewerTemplates().pipe(
        map(viewerTemplates => VetSettingsActions.loadViewerTemplatesSuccess({ viewerTemplates })),
        catchError(error => of(VetSettingsActions.loadViewerTemplatesFailure({ error })))
      )
    )
  ));

  saveViewerTemplate$ = createEffect(() => this.actions$.pipe(
    ofType(VetSettingsActions.saveViewerTemplate),
    mergeMap(({ request }) =>
      this.vetSettingsService.saveViewerTemplate(request).pipe(
        map(response => VetSettingsActions.saveViewerTemplateSuccess({ response })),
        catchError(error => of(VetSettingsActions.saveViewerTemplateFailure({ error })))
      )
    )
  ));

  // Add other effects as needed...

  constructor(
    private actions$: Actions,
    private vetSettingsService: VetSettingsService
  ) { }
}
